// immutable
import { fromJS } from "immutable"
// app
import * as types from "./types.js"
import { CLEAR_ERROR } from "actions/types.js"


const initialState = fromJS({
    error: false,
    fetching: false,
    data: {}
})

export function fetching(state) {
    if (!state) return false
    if (!state.get) return false
    return state.get("fetching", false)
}

export function error(state) {
    if (!state) return false
    if (!state.get) return false
    const error = state.get("error", false)
    if (error === false) return false
    return error
}

export default function(state = initialState, action) {
    switch (action.type) {
        // request
        case types.GET_PERSON_REQUEST:
        case types.PUT_PERSON_REQUEST:
            return state.set("fetching", true)
        // received
        case types.GET_PERSON_RECEIVED:
        case types.PUT_PERSON_RECEIVED:
            return state.withMutations(s => s
                .set("data", fromJS(action.payload))
                .set("fetching", false)
            )
        // error
        case types.GET_PERSON_ERROR:
        case types.PUT_PERSON_ERROR:
            return state.withMutations(s => s
                .set("error", action.payload)
                .set("fetching", false)
            )
        case CLEAR_ERROR:
            return state.delete("error")
        // default
        default:
            return state
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/person/reducer.js
 **/